'use strict';

const React = require('react');

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    const n = Object.create(null, { [Symbol.toStringTag]: { value: 'Module' } });
    if (e) {
        for (const k in e) {
            if (k !== 'default') {
                const d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: () => e[k]
                });
            }
        }
    }
    n.default = e;
    return Object.freeze(n);
}

const React__namespace = /*#__PURE__*/_interopNamespace(React);

const SvgArrowRedo = (props) => React__namespace.createElement(
  "svg",
  Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props),
  React__namespace.createElement("path", { fill: "#2D2E2E", fillRule: "evenodd", d: "m15.03 12 2.52-3H10.5a4.5 4.5 0 0 0 0 9h.5v2h-.5a6.5 6.5 0 1 1 0-13h7.05l-2.52-3h2.61L21 8l-3.36 4h-2.61Z", clipRule: "evenodd" })
);

module.exports = SvgArrowRedo;
//# sourceMappingURL=ArrowRedo.cjs.js.map
